import { makePharmacyTitle } from '../../../utils/makePharmacyTitle';

export default (pharmacy, formatMessage) => {
  return [
    {
      name: formatMessage({ id: 'appointments.form.pharmacyLocation' }),
      value: pharmacy ? makePharmacyTitle(pharmacy, true) : '-',
      fieldName: 'pharmacy',
      type: 'pharmacy',
    },
  ];
};



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/utils/generatePharmacyDescription.js